import styled from 'styled-components';
import { Card } from 'semantic-ui-react';
import { SelectField } from 'components/FormField';
import { StyledSearchableCard } from 'components/Modals/components/styles';
import { CardHeader } from 'views/Agreement/cards/AgreementCards.styles';
import DealershipIcon from 'assets/DealershipIcon';
import colors from 'styles/colors';
import { useIntl } from 'react-intl';
import styles from 'componentsV2/SearchableCard/SearchableCard.styles.less';

const StyledDealershipSearchableCard = styled(StyledSearchableCard)`
  margin-bottom: 16px;
`;

type HierarchyOption = {
  value: number | string;
  label: string;
};

type DealershipModalCardProps = {
  hierarchy: HierarchyOption[];
  selectedDealership: number | null;
  onSelect: (dealershipId: number) => void;
};

const DealershipModalCard = ({ hierarchy, selectedDealership, onSelect }: DealershipModalCardProps) => {
  const { formatMessage } = useIntl();

  const options = hierarchy
    .filter(({ value }) => typeof value === 'number')
    .map(({ value, label }) => ({
      value: String(value),
      label,
    }));

  return (
    <StyledDealershipSearchableCard>
      <div className={`${styles.searchableCard__wrapper} searchable-card-wrapper`}>
        <Card>
          <CardHeader $border>
            <DealershipIcon color={colors.fleetBlue} />
            {formatMessage({ id: 'views.tableFields.dealership' })}
          </CardHeader>
          <div className={`${styles.searchableCard__headerWrapper} searchable-card-header-wrapper`}>
            <div className={`${styles.searchableCard__searchWrapper} searchable-card-search-wrapper`}>
              <SelectField
                name="dealership"
                placeholder={formatMessage({ id: 'form.placeholders.selectADealership' })}
                options={options}
                value={(selectedDealership !== null ? String(selectedDealership) : null) as any}
                onChange={(event) => {
                  if (event && 'target' in event) {
                    onSelect(Number(event.target.value));
                  }
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </StyledDealershipSearchableCard>
  );
};

export default DealershipModalCard;
